import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import { countryApi } from '../../@types/countryData';
import URLConstants from 'constants/urlConstants';

type CountryState = {
    isLoading: boolean;
    error: boolean;
    countryList: countryApi[];
}

const initialState: CountryState = {
    isLoading: false,
    error: false,
    countryList: [],
}

const slice = createSlice({
    name: 'countryList',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // GET COUNTRY
        getCountrySuccess(state, action) {
            state.isLoading = false;
            state.countryList = action.payload;
        },
    }
});

// Reducer
export default slice.reducer;


export function getCountry() {
    return async () => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get(URLConstants.COUNTRIES_BASE_URL);
        dispatch(slice.actions.getCountrySuccess(response.data.data));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
  }